export default {"src":"/_next/static/media/eyeClosed.1778db25.svg","height":18,"width":20,"blurWidth":0,"blurHeight":0};